import { createSlice } from "@reduxjs/toolkit";
import { GetAddressFromLatLng } from "./AddressApi";

/**
 * @Email : jfragoso@ibl.mx
 * @Author: Jhovanny Fragoso Marquez
 * @jobTittle: Frontend Developer
 */

const AddressSlice = createSlice({
    name: "addressSection",
    initialState: {
        getAddressFromLatLng: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GetAddressFromLatLng.fulfilled, (state, action) => {
                state.getAddressFromLatLng = action.payload;
            })
            .addCase(GetAddressFromLatLng.rejected, (state, action) => {
                state.getAddressFromLatLng = action.payload;
            });
    },
});

export const { } = AddressSlice.actions;

export default AddressSlice.reducer;
